import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval, lastValueFrom, Subscription } from 'rxjs';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { UserService } from 'src/app/core/services/user.service';
import swal from 'sweetalert2';
import { environment } from '../../../../environments/environment';
import { Plan } from '../../../core/models/personalInfo';
import { AccountService } from '../../../core/services/account.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { NachPopComponent, UpdateStatusData } from '../nach-pop/nach-pop.component';
import { ENachAPIData } from 'src/app/core/interface/interfaces';

export interface AutoPayBody {
    firstname: string,
    surl: string,
    furl: string,
    udf5: string,
}

export interface DownpaymentBody {
    amount: string,
    txnid: string,
    firstname: string,
    surl: string,
    furl: string,
    auto_debit_access_key: string,
    customer_authentication_id: string
}

@Component({
    selector: 'app-nach-mandate',
    templateUrl: './nach-mandate.component.html',
    styleUrls: ['./nach-mandate.component.scss'],
})
export class NachMandateComponent implements OnInit {
    private cd = inject(ChangeDetectorRef);

    @ViewChild('ifscCode')
    public ifscCode: ElementRef;

    @ViewChild(NachPopComponent)
    public nachpopup: NachPopComponent;

    private easebuzzCheckout: any;

    private MerchantKey: string = '';

    public nachForm: UntypedFormGroup;

    public PayUForm: UntypedFormGroup;

    public loanagreementurl!: string;

    public redirectUrl!: string;

    public plans!: Plan[];

    public conditionAccept: boolean = true;

    public baseUrl!: string;

    public nachStatus: boolean = false;

    public NachUniqueId: string;

    public NachUrl: string;

    public paymentStatusSubscription: Subscription;

    public updateStatusData: UpdateStatusData = {
        mandateId: '',
        status: ''
    }

    public isProd: Boolean = false;

    public autoPayBody: AutoPayBody = {
        firstname: "",
        surl: "",
        furl: "",
        udf5: ""
    }

    public autoDownpayment: DownpaymentBody = {
        amount: '',
        txnid: '',
        firstname: '',
        surl: '',
        furl: '',
        auto_debit_access_key: '',
        customer_authentication_id: ''
    }

    public orderId: string = '';

    public isAutoPayLoading = false;

    public downpay3tries = 0;

    public emiAmount: any = '';

    public collectionAmount: any = 0;

    public nachTried: number = 0;

    public isPayU = false;

    public vpaError: string = '';

    public enableSubmitPayU = false;

    public digio_doc_id!: string;

    public message!: string;

    public npci_txn_id!: string;

    public status!: string;

    public selectedPlan!: Plan;

    public order_id: string;

    public eNachData: ENachAPIData;

    public validation = {
        isValid: false,
        message: ''
    }

    public get m() {
        return this.nachForm.controls;
    }

    constructor(private route: ActivatedRoute, private accountService: AccountService, private router: Router, private formBuilder: UntypedFormBuilder, private http: HttpClient,
        private spinner: NgxSpinnerService, private sessionTimerService: SessionTimerService, private userService: UserService
    ) {
        this.baseUrl = environment.apiUrl + 'assistmodule/v1/createUserProfile';
        //this.redirectUrl = environment.frontEndUrl + 'assist-journey/payment-gateway';
        this.redirectUrl = environment.frontEndUrl + 'assist-journey/payment-gateway?source=digio';
        this.selectedPlan = JSON.parse(MemoryStorageService.getItem('finalplan')!);

        var user = JSON.parse(MemoryStorageService.getItem('user')!);

        this.emiAmount = [user['emiamount']];

        this.collectionAmount = this.selectedPlan['emi_amount'] * this.selectedPlan['tenor']
        this.nachForm = formBuilder.group({
            bankId: [
                '',
                [Validators.required, Validators.pattern('^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$')],
            ],
            requestCode: ['5016'],//gen nach mandate
            accountNumber: [
                '',
                [Validators.required, Validators.pattern('^[0-9]{9,18}$')]
            ],
            bankName: [
                '',
                Validators.required
            ],
            accountType: [
                '',
                [Validators.required]
            ]
            ,
            //collectionAmount: [user['emiamount']],
            //collectionAmount: [user['collectionAmount']],
            collectionAmount: Math.round(this.selectedPlan['emi_amount'] * this.selectedPlan['tenor']),
            customerName: [user['fullname']],
            firstCollectionDate: [user['firstCollectionDate']],
            redirectUrl: this.redirectUrl,
            chkAgree: [true, Validators.requiredTrue]
        });

        this.PayUForm = formBuilder.group({
            autoPayIds: [],
        });
    }

    public ngOnInit(): void {

        this.spinner.hide();

        this.isProd = environment.production;

        this.MerchantKey = environment.easeBuzzAutoPayKey;

        if (window['EasebuzzCheckout']) {
            this.easebuzzCheckout = new window['EasebuzzCheckout'](this.MerchantKey, environment.easeBuzzEnvironment);
        } else {
            console.error('EasebuzzCheckout script is not loaded.');
        }

        this.autoFillNachForm();

        // if (this.eNachData && this.eNachData.accountNumber) {
        this.nachForm.get('accountNumber').valueChanges
            .subscribe(value => this.validateAccountNumber(value));
        // }

        //Use Autopay if LoanAmount < 15000
        //disabling the Auto until the PayU AutoPay resolved - resolved
        if (environment.showeasebuzz && !environment.showPayU && this.collectionAmount < 50000) {
            this.spinner.show();
            this.isAutoPayLoading = true;

            const orderid = MemoryStorageService.getItem('OrderId');

            if (environment.production) {
                this.migrateSessionToLocalStorage();
            }

            if (orderid) {
                this.onCheckout(orderid);
            } else {
                this.autoPayBody.firstname = this.nachForm.value.customerName;
                //this.autoPayBody.udf5 = this.nachForm.value.collectionAmount;
                this.autoPayBody.udf5 = Math.round(this.selectedPlan['emi_amount'] * this.selectedPlan['tenor']) + '';
                this.autoPayBody.surl = environment.frontEndUrl + "assist-journey/payment-gateway";
                this.autoPayBody.furl = environment.frontEndUrl + "assist-journey/nach-mandate";

                this.http.post(environment.apiUrl + "Menedo/AutoPayInitiate", this.autoPayBody).subscribe((response) => {
                    if (response['data'] != null) {
                        const autoPayResponse = JSON.parse(response['data']);
                        this.orderId = autoPayResponse.data;
                        if (this.orderId) {
                            this.onCheckout(this.orderId);
                        }
                    }
                });
            }

        }
        else if (environment.showPayU && this.collectionAmount < 50000) {
            this.isAutoPayLoading = true;
            this.isPayU = true;
        }
    }

    public ngOnDestroy(): void {
        if (this.isProd && this.paymentStatusSubscription) {
            this.paymentStatusSubscription.unsubscribe();
        }
    }

    public openPopup(url: string, mandateId: string): void {
        this.startPaymentStatusCheck();
        document.getElementById('popup-nach')!.style.display = 'block';
        document.getElementById('overlay-nach')!.style.display = 'block';
        url = url.includes("https") ? url : "https://" + url;
        this.nachpopup.openWindow(url, mandateId);
    }

    public startPaymentStatusCheck(): void {
        if (this.paymentStatusSubscription) {
            this.paymentStatusSubscription.unsubscribe();
        }

        this.paymentStatusSubscription = interval(10000).subscribe(async () => {
            const response = await lastValueFrom(this.accountService.GetNachStatus(this.NachUniqueId));
            if (response['data']) {
                const data = response['data'];
                if (data.customer.accptd === 'accepted') {
                    //Update Status to Accepted
                    if (this.paymentStatusSubscription) {
                        this.paymentStatusSubscription.unsubscribe();
                    }
                    this.updateStatusData.status = 'accepted';
                    this.accountService.UpdateMandateStatus(this.updateStatusData).subscribe((response) => {
                        this.accountService.updateNACHApplicationStatus(this.NachUniqueId, 2).subscribe((response) => {
                            this.nachpopup.CloseWindow();
                            this.router.navigateByUrl('/assist-journey/payment-gateway');
                        });
                    });
                }
                else if (data.customer.accptd === 'rejected') {
                    //Update Status to Rejected
                    if (this.paymentStatusSubscription) {
                        this.paymentStatusSubscription.unsubscribe();
                    }
                    this.updateStatusData.status = 'rejected';
                    this.accountService.UpdateMandateStatus(this.updateStatusData).subscribe((response) => {
                        this.accountService.updateNACHApplicationStatus(this.NachUniqueId, 0).subscribe((response) => {
                            document.getElementById('popup-nach')!.style.display = 'none';
                            document.getElementById('overlay-nach')!.style.display = 'none';
                            this.nachpopup.CloseWindow();

                            /*** Redirect if Nach Failed for Sterling Holidays ***/
                            if (environment.sterlingHolidaysConsolidator.includes(MemoryStorageService.getItem("consolidatorId"))) {
                                const data = { partnerTransactionId: MemoryStorageService.getItem("partnerTransactionId"), status: "NachFailed" };
                                this.userService.redirectWithPost(localStorage.getItem('partnercallback'), data);
                                return;
                            }
                            /*******************/

                            swal.fire("NACH Mandate Failed");
                            return this.router.navigateByUrl('/assist-journey/assist-underwrite?redirect=' + localStorage.getItem('partnercallback'));
                        });
                    });

                }
            }
        });
    }

    public async onSubmit() {
        console.log(this.baseUrl);
        console.log(this.nachForm.value);

        if (this.isProd)
        //if(true)
        {
            this.spinner.show();
            this.accountService.CheckMandate(MemoryStorageService.getItem("customerToken")).subscribe(async (response) => {
                if (response['data'] != null) {
                    this.NachUniqueId = response['data'].mandateid;
                    this.NachUrl = response['data'].url;
                    this.updateStatusData.mandateId = this.NachUniqueId;
                    this.openPopup(this.NachUrl, this.NachUniqueId);
                }
                else {
                    try {
                        if (response['error'] && response['error'].response_msg === 'Link Expired') {
                            this.updateStatusData.mandateId = response['error'].mandateid;
                            this.updateStatusData.status = 'rejected';
                            this.accountService.UpdateMandateStatus(this.updateStatusData).subscribe((response) => { });
                        }
                        if (response['error'] && response['error'].response_msg === 'Request approved') {
                            this.router.navigateByUrl('/assist-journey/loan-agreement');
                        }
                    } catch (error) {
                        // If exception occured, doesn't matter though, updating expired link status not mandatory
                        console.log(error);
                    }
                    return await this.http.post(this.baseUrl, this.nachForm.value).subscribe({
                        next: (response: any) => {
                            console.log(response);
                            if (response['error'] == null) {
                                const data = response['data'];
                                console.log(data['url']);
                                this.NachUniqueId = data.customer.id;
                                this.NachUrl = data['url'];
                                this.updateStatusData.mandateId = this.NachUniqueId;
                                this.openPopup(this.NachUrl, this.NachUniqueId);
                                //window.open(JSON.parse(response['data'])['redirectUrl'], '_parent');
                                this.spinner.hide();
                                this.nachForm.reset();
                            } else {
                                console.log(response);
                                console.log(response['error']);
                                console.log(JSON.parse(response['error']));
                                let e = JSON.parse(response['error']);
                                this.spinner.hide();
                                this.router.navigateByUrl('/assist-journey/pleasewait');
                            }
                        },
                    });
                }
            });

        }

        // UAT/DEV use digio NACH API
        else {
            this.spinner.show();
            return await this.http.post(this.baseUrl, this.nachForm.value).subscribe({
                next: (response: any) => {
                    console.log(response);
                    if (response['error'] == null) {

                        let counter = parseInt(localStorage.getItem('nachDigioCounter')) || 0;
                        counter++;
                        localStorage.setItem('nachDigioCounter', counter + '');

                        window.open(JSON.parse(response['data'])['redirectUrl'], '_parent');
                        this.nachForm.reset();
                        this.spinner.hide();
                    } else {
                        console.log(response);
                        console.log(response['error']);
                        console.log(JSON.parse(response['error']));
                        let e = JSON.parse(response['error']);
                        this.spinner.hide();
                        this.router.navigateByUrl('/assist-journey/pleasewait');
                    }
                },
            });
        }
        this.spinner.hide();
    }

    public onCheckout(orderId: string): void {
        if (!this.easebuzzCheckout) {
            console.error('EasebuzzCheckout script is not loaded.');
            return;
        }

        if (orderId.toLowerCase().includes('error')) {
            console.log("Something went wrong!");
        }

        const options = {
            access_key: orderId,
            onResponse: (response: any) => {
                console.log(response);
                this.onAutoPayResponse(response);
            },
            theme: '#123456' // color hex
        };
        this.easebuzzCheckout.initiatePayment(options);
    }

    private onAutoPayResponse(response: any) {
        console.log(response);
        if (response.hasOwnProperty('status') && response.status.toLowerCase() === 'success') {
            // this.initiateDownpayment(response);  // removing as debit can be made after 48Hrs
            // save status
            this.updateStatusData.mandateId = this.orderId;
            this.updateStatusData.status = 'accepted';
            this.accountService.UpdateAutoPayMandateStatus(this.updateStatusData).subscribe((response) => {
                this.accountService.updateNACHApplicationStatus(this.orderId, 2).subscribe((response) => {
                    const url = localStorage.getItem('partnercallback')
                    const orderId = MemoryStorageService.getItem('OrderId');
                    if (url != null && url !== 'undefined' && url != '' && orderId != null && orderId !== 'undefined' && orderId != '') {
                        window.location.href = url;
                    }
                    else {
                        this.router.navigateByUrl('/assist-journey/payment-gateway');
                        //window.location.href = this.redirectUrl + "?status=success";
                    }
                });
            });
        }
        else {
            // Already Paid Check ------------------------------------------- 
            // if(error['message'] == "paid like something message - need to check"){
            //   // redirect to next page then or Back to redirectUrl ....
            // const url = MemoryStorageService.getItem('partnercallback')
            // const orderId = MemoryStorageService.getItem('OrderId');
            // if(url != null && url !== 'undefined' && url != '' && orderId != null && orderId !== 'undefined' && orderId != '')
            // {
            //    window.location.href = url;
            // }
            // else {            
            //    this.router.navigateByUrl('/assist-journey/payment-gateway?source=upi');
            // }
            // }
            // this.nachTried = localStorage.getItem('nachTried') ? parseInt(localStorage.getItem('nachTried')) : 0;
            // if (this.nachTried < 3) {
            //   swal.fire(response.message);
            //   this.spinner.hide();
            //   this.nachTried += 1;

            //   localStorage.setItem('nachTried', this.nachTried + '');
            //   location.reload();
            // }
            // else {
            this.updateStatusData.mandateId = this.orderId;
            this.updateStatusData.status = 'rejected';
            this.accountService.UpdateAutoPayMandateStatus(this.updateStatusData).subscribe((response) => {
                this.accountService.updateNACHApplicationStatus(this.orderId, 0).subscribe((response) => {

                    /*** Redirect if Nach Failed for Sterling Holidays ***/
                    if (environment.sterlingHolidaysConsolidator.includes(MemoryStorageService.getItem("consolidatorId"))) {
                        const data = { partnerTransactionId: MemoryStorageService.getItem("partnerTransactionId"), status: "NachFailed" };
                        this.userService.redirectWithPost(localStorage.getItem('partnercallback'), data);
                        return;
                    }
                    /*******************/

                    window.location.reload();
                    //return this.router.navigateByUrl('/assist-journey/nach-mandate');
                    //return this.router.navigateByUrl('/assist-journey/assist-underwrite?redirect=' + localStorage.getItem('partnercallback'));
                });
            });
            // }
        }
    }

    private initiateDownpayment(response) {
        this.spinner.show();
        if (response.hasOwnProperty("auto_debit_access_key") && response.auto_debit_access_key != '') {
            this.autoDownpayment.firstname = this.nachForm.value.customerName;
            //let amount: number = this.selectedPlan['emi_amount'];
            //this.autoDownpayment.amount = amount.toFixed(2);
            this.autoDownpayment.auto_debit_access_key = response.auto_debit_access_key;
            this.autoDownpayment.customer_authentication_id = response.customer_authentication_id;
            //this.autoDownpayment.txnid = response.txnid;
            this.autoDownpayment.surl = environment.frontEndUrl + "assist-journey/assist-success";
            this.autoDownpayment.furl = environment.frontEndUrl + "assist-journey/nach-mandate";

            this.http.post(environment.apiUrl + "Menedo/AutoPayDownPayment", this.autoDownpayment).subscribe((response) => {
                if (response['data'] != null && (JSON.parse(response['data']).status === 1 || JSON.parse(response['data']).data === "Auto debit request accepted successfully")) {
                    console.log(response['data'])
                    swal.fire("Downpayment Successful!");
                    swal.fire({
                        text: 'Downpayment Successful!',
                        //icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed || result.isDenied || result.isDismissed) {
                            this.router.navigateByUrl('/assist-journey/assist-success');
                        }
                    });
                    this.spinner.hide();
                }
                else if (response['error'] != null) {
                    console.log(response);
                    if (this.downpay3tries > 3) {
                        this.downpay3tries += 1;
                        setTimeout(() => { this.initiateDownpayment(response); }, 1000);
                    }
                    else {
                        swal.fire({
                            text: 'Downpayment failed!',
                            //icon: 'error',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed || result.isDenied || result.isDismissed) {
                                this.router.navigateByUrl('/assist-journey/sorry');
                            }
                        });
                    }
                }
                else {
                    swal.fire({
                        text: 'Downpayment failed!',
                        //icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed || result.isDenied || result.isDismissed) {
                            this.router.navigateByUrl('/assist-journey/sorry');
                        }
                    });
                }
            });
        }
    }

    /**
     * Fetches the Nach data using the customer Token.
     * If validationRequired from the is false then
     * Automatically fill the data to corresponding controls and disable the controls.
     */
    private autoFillNachForm() {
        const token = MemoryStorageService.getItem('customerToken');

        this.accountService.getNachFormData(token).subscribe({
            next: (response: any) => {
                const { data, error } = response;

                this.eNachData = data;

                if (error) {
                    console.log(error);
                } else {
                    if (!this.eNachData.validationRequired) {
                        this.eNachData.accountType === 'SAVING' ?
                            this.nachForm.get('accountType').setValue('Savings') : this.nachForm.get('accountType').setValue('Current');
                        this.nachForm.get('accountType').disable();
                        this.nachForm.get('accountNumber').setValue(this.eNachData.accountNumber);
                        this.nachForm.get('bankId').setValue('');
                    }
                }
            },
            error: (error: Error) => {
                console.log(error, "Nach form data error");
            }
        });
    }

    /**
     * Validates the accountNumber entred by user and accountNumber from Nach prefil api.
     * @param value accountNumber
     */
    private validateAccountNumber(value: string) {
        const accountNumber = value;

        // Ensure accountNumber exists and that eNachData.accountNumber is available
        if (this.eNachData && this.eNachData.validationRequired) {
            let isValid = true;
            let message = 'Account Number is Matching ';

            // Check if the account number is longer than expected
            if (accountNumber.length > this.eNachData.accountNumber.length) {
                console.log('greater');
                isValid = false;
                message = 'Account Number is too Long.';
            }

            // Loop through each character to compare against the expected account number
            for (let i = 0; i < this.eNachData.accountNumber.length; i++) {
                if (this.eNachData.accountNumber[i] !== 'X' && this.eNachData.accountNumber[i] !== accountNumber[i]) {
                    console.log("wrong");
                    isValid = false;
                    message = 'Account Number is Not Matching';
                    break; // No need to check further once a mismatch is found
                }
            }

            // Update validation state
            this.validation = { isValid, message };

            // Set errors on the form control if not valid
            if (!isValid) {
                this.nachForm.get('accountNumber').setErrors({ accountNumberMismatch: message });
            } else {
                // Clear errors if valid
                this.nachForm.get('accountNumber').setErrors(null);
            }

            // Mark the form control as touched
            this.nachForm.get('accountNumber').markAsTouched();
        }
    }

    private migrateSessionToLocalStorage() {
        for (const [key, value] of Object.entries(sessionStorage)) {
            localStorage.setItem(key, value);
        }
    }

    async onSubmitPayU() {
        this.spinner.show();
        const UPIId = this.PayUForm.get('autoPayIds')?.value;
        if (UPIId) {
            const obj = { amount: this.selectedPlan['emi_amount'] }
            await lastValueFrom(this.accountService.PayUGenerateAutoPay(obj)).then(res => {
                const data = res['data'];
                if (data == null) {
                    this.spinner.hide();
                    this.router.navigateByUrl("/assist-journey/session-expired");
                    return;
                }

                if (data != null) {
                    const formData = {
                        key: environment.PayUKey,
                        txnid: data.txnId,
                        amount: data.amount,
                        firstname: data.firstname,
                        email: data.email,
                        phone: data.phone,
                        productinfo: "Selfin",
                        api_version: "7",
                        si: "1",
                        pg: "UPI",
                        bankcode: "UPI",
                        vpa: UPIId,
                        // surl: environment.frontEndUrl + "assist-journey/assist-success?source=nupay&status=success&redirect=" + localStorage.getItem('partnercallback'),
                        // furl: environment.frontEndUrl + "assist-journey/assist-underwrite?redirect="+ localStorage.getItem('partnercallback'),
                        surl: environment.apiUrl + "payment/redirect/success",
                        furl: environment.apiUrl + "payment/redirect/failed",
                        si_details: data.si_details,
                        hash: data.hash
                    };

                    if (!environment.production) {
                        formData.vpa = "9999999999@upi";
                    }

                    this.spinner.hide();
                    return this.userService.redirectWithPostNoEncrypt(environment.PayUUrl, formData);
                }


            }).catch(err => {
                console.log(err);
                this.spinner.hide();
                return this.router.navigateByUrl("/assist-journey/session-expired");
            });

        }
    }

    async verifyVPA() {
        this.spinner.show();
        const UPIId = this.PayUForm.get('autoPayIds')?.value;

        if (!environment.production) {
            this.vpaError = '';
            this.enableSubmitPayU = true;
            this.vpaError = 'Test User';
            this.spinner.hide();
            return;
        }

        try {
            const res = await lastValueFrom(this.accountService.PayUValidateVPA(UPIId));
            if (res['data'] != null) {
                const jsonData = JSON.parse(res['data']);
                if (jsonData['status'].toLowerCase() === 'success' && jsonData['isVPAValid'] === 1 && jsonData['payerAccountName'] !== "NA" && jsonData['isAutoPayVPAValid'] === 1) {
                    this.vpaError = '';
                    this.enableSubmitPayU = true;
                    this.vpaError = jsonData['payerAccountName'];
                    this.spinner.hide();
                }
                else if (jsonData['isAutoPayVPAValid'] === 0) {
                    this.vpaError = 'UPI not supported for Auto Pay';
                    this.enableSubmitPayU = false;
                    this.spinner.hide();
                }
                else {
                    this.vpaError = 'Invalid UPI';
                    this.enableSubmitPayU = false;
                    this.spinner.hide();
                }
            }
            else {
                this.vpaError = res['error'];
                this.enableSubmitPayU = false;
                this.spinner.hide();
            }
        } catch (err) {
            this.vpaError = 'Invalid UPI';
            this.enableSubmitPayU = false;
            this.spinner.hide();
        }
    }

    public checkValue(event: any) {
        this.conditionAccept = event['target']['checked'];
    }

    public upperCase(event: any) {
        const input = event.target;
        input.value = input.value.toUpperCase();
    }

    public bankName: string = '';

    public getBankName(event: any) {
        this.accountService.getNachLiveDestinationBanks({ ifsc: this.nachForm.controls.bankId.value }).subscribe({
            next: (responseLiveBanks: any) => {
                console.log(responseLiveBanks);
                this.http.get('https://ifsc.razorpay.com/' + this.nachForm.controls.bankId.value).subscribe({
                    next: (response: any) => {
                        if (response['data'] !== 'null') {
                            console.log(response);

                            if (environment.production) {
                                this.accountService.getBankList(response['BANKCODE']).subscribe((res: any) => {
                                    if (res['data'] != null) {
                                        this.bankName = (response['BANK'] + ' ' + response['BRANCH']);
                                    }
                                    else {
                                        swal.fire(response['IFSC'] + '-' + response['BANK'] + ' ' + response['BRANCH'] + ' is not valid for E-Mandate. Please choose a valid Bank');
                                    }
                                })
                            } else {
                                this.bankName = (response['BANK'] + ' ' + response['BRANCH']);
                                this.nachForm.get('bankName').patchValue(response['BANK']);
                            }
                        }
                        else {
                            console.log(response, "response")
                            swal.fire(response['IFSC'] + '-' + response['BANK'] + ' ' + response['BRANCH'] + ' is not valid for E-Mandate. Please choose a valid Bank');
                        }
                    },
                    error: (error: Error) => {
                        console.log(error);
                    }
                });
            },
        });
    }

}
